import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

/**
 * Composant qui enveloppe les routes privées.
 * Il vérifie si un token JWT existe dans le localStorage.
 */
const ProtectedRoute = ({ children, requiredRole }) => {
  const token = localStorage.getItem('token');
  const userRole = localStorage.getItem('role'); // "ADMIN" ou "SUPER_ADMIN"
  const location = useLocation();

  // 1. Si pas de token -> Redirection vers login
  if (!token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 2. Si un rôle spécifique est requis (ex: SUPER_ADMIN)
  if (requiredRole && userRole !== requiredRole) {
    console.warn(`Accès refusé : rôle ${requiredRole} requis.`);
    return <Navigate to="/admin" replace />; // Redirige vers le dashboard par défaut
  }

  // 3. Si tout est ok, on affiche la page demandée
  return children;
};

export default ProtectedRoute;